import React, { useState, useEffect } from 'react'
import { getPermisosPerforacion } from '../../service/apiBackEnd.js';
import { Container, Row, Col } from 'react-bootstrap';
import styles from '../index.module.css';

const PermisosPerforacion = () => {
    const [allData, setAllData] = useState([]);
    const [enrichedData, setEnrichedData] = useState([]); // Nuevo estado para los datos enriquecidos

    useEffect(() => {
        const fetchData = async () => {
            const res = await getPermisosPerforacion();
            console.log("DATA", res);
            setAllData(res);
        };
        fetchData();
    }, []);

    useEffect(() => {
        const getMediaUrl = async (mediaId) => {
            try {
                const response = await fetch(`http://epas.test.di.dgi.loc/wp-json/wp/v2/media/${mediaId}`);
                const mediaData = await response.json();
                return mediaData.source_url;
            } catch (error) {
                console.error("Error fetching media:", error);
                return null;
            }
        };

        const fetchMediaUrls = async () => {
            const updatedData = await Promise.all(
                allData.map(async (elem) => {
                    const archivoUrl = elem.acf?.adjuntar_archivo
                        ? await getMediaUrl(elem.acf.adjuntar_archivo)
                        : null;
                    const archivoUrl2 = elem.acf?.adjuntar_archivo_2
                        ? await getMediaUrl(elem.acf.adjuntar_archivo_2)
                        : null;

                    return { ...elem, archivoUrl, archivoUrl2 };
                })
            );
            setEnrichedData(updatedData); // Guardar los datos enriquecidos por separado
        };

        if (allData.length > 0 && enrichedData.length === 0) { // Solo si aún no se han enriquecido los datos
            fetchMediaUrls();
        }
    }, [allData, enrichedData]);

    console.log("DATAAAA", enrichedData);

    return (
        <Container>
            <Row>
                <h1 className="mt-5 mb-4">FACTIBILIDAD DE SERVICIO</h1>
                {enrichedData.map((item, index) => {
                    console.log("ITEM", item);
                    return (
                        <Col key={index} className='mb-4'>
                            <h4>RECOMENDACIONES DE DIRCAS PARA LA COMPRA DE LOTES PARA EDIFICAR VIVIENDA</h4>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: item.acf.factibilidades_y_permisos,
                                }}
                            />
                            <hr></hr>

                            <h4>REQUISITOS AL SOLICITAR AUTORIZACIÓN PARA EJECUTAR PERFORACIONES COMO FUENTE DE AGUA PARA USO HUMANO</h4>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: item.acf?.requisitos_al_solicitar_autorizacion
                                    ,
                                }}
                            />

                            {item.archivoUrl && (
                                <a href={item.archivoUrl} target="_blank" rel="noopener noreferrer" download className={styles.btnDescarga}>
                                    Formulario Nueva Perforación
                                </a>
                            )}


                            <hr></hr>

                            <h4>INSTRUCTIVO PARA SOLICITAR AUTORIZACIÓN PARA CAMBIO DEL USO DE PERFORACIÓN EXISTENTE A CONSUMO HUMANO</h4>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: item.acf?.autorizacion_para_cambio_de_uso,
                                }}
                            />
                            {item.archivoUrl2 && (
                                <a href={item.archivoUrl2} target="_blank" rel="noopener noreferrer" download className={styles.btnDescarga}>
                                    Formulario Permiso Cambio de Uso Perforación
                                </a>
                            )}
                        </Col>
                    )
                })}

            </Row>
        </Container>
    );
};
export default PermisosPerforacion;
